<template>
  <b-card class="mb-0">
    <h6 class="mb-3">{{ title }}</h6>
    <div v-if="steps.length">
      <b-row
        v-for="(step, index) in steps"
        :key="`approval-step-${step.step}-${index}`"
        class="mb-2"
      >
        <b-col cols="4" class="d-flex align-items-center">
          <strong>Bước {{ step.step }}</strong>
        </b-col>
        <b-col cols="8">
          <Autosuggest
            :model="getModel(index)"
            :suggestions="getSuggestions(step)"
            :suggestionName="'name'"
            :placeholder="`người duyệt bước ${step.step}`"
            :limit="50"
            @select="onSelect($event, index)"
            @change="onInput($event, index)"
          >
            <template #custom="{ suggestion }">
              {{ suggestion.item.name }} ({{ suggestion.item.id }})
            </template>
          </Autosuggest>
        </b-col>
      </b-row>
    </div>
    <div v-else class="text-muted">
      {{ emptyText }}
    </div>
  </b-card>
</template>

<script>
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';

export default {
  name: 'ApprovalStepSearchSelector',
  components: { Autosuggest },
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'Quy trình duyệt',
    },
    emptyText: {
      type: String,
      default: 'Chưa có cấu hình duyệt.',
    },
  },
  data() {
    return {
      inputModels: {},
    };
  },
  watch: {
    steps: {
      immediate: true,
      deep: true,
      handler(newSteps) {
        const nextModels = {};
        (newSteps || []).forEach((step, index) => {
          const selected = (step.owners || []).find(
            (owner) => Number(owner.id) === Number(step.approverBy),
          );
          nextModels[index] = selected ? selected.name : '';
        });
        this.inputModels = nextModels;
      },
    },
  },
  methods: {
    getSuggestions(step) {
      return (step.owners || []).map((owner) => ({
        id: Number(owner.id),
        name: owner.name ? owner.name : `${owner.id}`,
      }));
    },
    getModel(index) {
      return this.inputModels[index] || '';
    },
    emitChangedSteps(index, approverBy) {
      const next = (this.steps || []).map((step, stepIdx) => {
        if (stepIdx !== index) return step;
        return {
          ...step,
          approverBy,
        };
      });
      this.$emit('change', next);
    },
    onSelect(option, index) {
      const item = option && option.item ? option.item : null;
      if (!item) {
        this.inputModels = { ...this.inputModels, [index]: '' };
        this.emitChangedSteps(index, null);
        return;
      }
      this.inputModels = { ...this.inputModels, [index]: item.name };
      this.emitChangedSteps(index, Number(item.id));
    },
    onInput(text, index) {
      const value = (text || '').toString();
      this.inputModels = { ...this.inputModels, [index]: value };
      if (!value.trim()) {
        this.emitChangedSteps(index, null);
      }
    },
  },
};
</script>
